import Card from '@eversports/react-components/primitives/Card'
import Flex from '@eversports/react-components/primitives/Flex'
import React from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@eversports/react-components/design-tokens/theme'
import Skeleton from '@eversports/react-components/primitives/Skeleton'

const useStyles = makeStyles((theme: Theme) => ({
  activityInformation: {
    flex: '60%',
    padding: theme.layoutSpacing.wide,
  },
  image: {
    flex: '40%',
  },
}))

const DesktopSkeletonBookingDetails = () => {
  const classes = useStyles()

  return (
    <Card raised>
      <Flex justifyContent="space-between">
        <div className={classes.activityInformation}>
          <Flex flexDirection="column" verticalSpacing={['dense', 'wide']}>
            <Skeleton variant="text" height="28px" width="156px" />
            <div>
              <Flex flexDirection="column" marginBottom="wide">
                <Skeleton variant="text" height="24px" width="128px" />
                <Skeleton variant="text" height="24px" width="128px" />
                <Skeleton variant="text" height="24px" width="128px" />
              </Flex>
              <Flex flexDirection="column" verticalSpacing="default">
                <Skeleton variant="text" height="20px" width="182px" />
                <Skeleton variant="text" height="20px" width="182px" />
              </Flex>
            </div>
          </Flex>
        </div>
        <Skeleton variant="rectangular" height="265px" className={classes.image} />
      </Flex>
    </Card>
  )
}

export default DesktopSkeletonBookingDetails
